import { Box } from "@mui/material";

export default function GardenBoundaryPreview({ geometry }) {
    if (
        !geometry?.coordinates ||
        geometry.coordinates.length < 2
    ) {
        return null;
    }

    let coordinates = [...geometry.coordinates];

    const first = coordinates[0];
    const last = coordinates[coordinates.length - 1];

    if (
        first[0] !== last[0] ||
        first[1] !== last[1]
    ) {
        coordinates.push(first);
    }

    const lats = coordinates.map((c) => c[0]);
    const lons = coordinates.map((c) => c[1]);

    const minLat = Math.min(...lats);
    const maxLat = Math.max(...lats);
    const minLon = Math.min(...lons);
    const maxLon = Math.max(...lons);

    const width = 256;
    const height = 256;
    const padding = 10;

    const lonRange = Math.max(maxLon - minLon, 0.00001);
    const latRange = Math.max(maxLat - minLat, 0.00001);

    const points = coordinates
        .map(([lat, lon]) => {
            const x =
                padding +
                ((lon - minLon) / lonRange) *
                    (width - padding * 2);

            const y =
                height -
                padding -
                ((lat - minLat) / latRange) *
                    (height - padding * 2);

            return `${x},${y}`;
        })
        .join(" ");

    return (
        <Box
            sx={{
                width,
                height,
                borderRadius: 3,
                backgroundColor:
                    "var(--color-green-soft)",
                border:
                    "1px solid rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <svg
                width={width}
                height={height}
                viewBox={`0 0 ${width} ${height}`}
            >
                <polygon
                    points={points}
                    fill="rgba(36,88,42,0.20)"
                    stroke="var(--color-green-main)"
                    strokeWidth="2"
                />
            </svg>
        </Box>
    );
}